class PloneApi {
    constructor() {
        if(process.env.NODE_ENV === 'production') {
            this.publicPath = "";
            this.siteId = "lkdigit";
            //this.serverBase = "https://landeskunde-digital.de/" + this.siteId;
            this.serverBase = "https://lkdigi.saw-leipzig.de/" + this.siteId;
        } else {
            this.publicPath = "";
            this.siteId = "lkdigit";
            this.serverBase = location.protocol + "//" + location.hostname + ":8080/" + this.siteId;
        }
    }

    sanitizeUrl(url) {
        if(url.indexOf(this.serverBase) === 0) {
            url = url.slice(this.serverBase.length);
        }
        if(url.charAt(0) !== "/") {
            url = "/" + url;
        }
        return this.publicPath + url;
    }

    sanitize(data) {
        if(typeof data === "object") {
            if(data.hasOwnProperty("@id")) {
                data["@id"] = this.sanitizeUrl(data["@id"]);
                data["@id"] = data["@id"].replace("&expand=breadcrumbs", "").replace("?expand=breadcrumbs", "");
            }

            if(data.hasOwnProperty("coordinates")) {
                if(data.coordinates.trim() === "") {
                    data.coordinates = null;
                } else {
                    const coordinates = data.coordinates.match(/[\d]{1,3}\.[\d]+/g);
                    data.coordinates = {
                        lat: parseFloat(coordinates[1]),
                        lon: parseFloat(coordinates[0])
                    }
                }
            }

            const sanitizeChildrenKeys = [
                "items",
                "parent",
                "referenced-panoramas",
                "referenced-lkd-content",
                "@components",
                "breadcrumbs"
            ];

            sanitizeChildrenKeys.forEach(childrenKey => {
                if(data.hasOwnProperty(childrenKey)) {
                    this.sanitize(data[childrenKey]);
                    for (var key in data[childrenKey]) {
                        if (data[childrenKey].hasOwnProperty(key)) {
                            this.sanitize(data[childrenKey][key]);
                        }
                    }
                }
            });
        }
    }

    fetch(url, expandBreadcrumbs = false) {
        if(url.charAt(0) === "/") {
            url = url.slice(1);
        }

        if(expandBreadcrumbs) {
            if(url.indexOf("?") > -1) {
                url += "&expand=breadcrumbs";
            } else {
                url += "?expand=breadcrumbs";
            }

        }

        const fetchPromise = new Promise((resolve, reject) => {
            fetch(this.serverBase + "/" + url, {
                headers: {
                    "Accept": "application/json",
                }
            })
            .then(response => {
                if (response.status !== 200) {
                    console.log('Looks like there was a problem. Status Code: ' + response.status);
                    reject(response);
                }

                // Examine the text in the response
                response.json().then(data => {
                    this.sanitize(data);
                    this.getDefaultPage(data)
                        .then(defaultPageObject => {
                            data["index_page"] = defaultPageObject;
                            resolve(data);
                        })
                        .catch(err => {
                            resolve(data);
                        });

                });
            })
            .catch(err => {
			    console.log('Fetch Error :-S', err);
			    reject(err);
		    });
        });

        return(fetchPromise);
    }

    getChildren(url) {
        const fetchUrl = url + "/@search?fullobjects=1&path.depth=1";
        return this.fetch(fetchUrl);
    }

    getDefaultPage(data) {
        if(["Plone Site", "Folder"].indexOf(data["@type"]) < 0) {
            return new Promise((resolve, reject) => {
                reject();
            });
        }

        let defaultChild = null;
        if (data.items.some(child => {
            let childId = child["@id"].slice(data["@id"].length);
            if(childId[0] === "/") {
                childId = childId.slice(1);
            }

            if(childId === "index_page") {
                defaultChild = child;
                return true;
            }
            return null;
        })) {
            return this.fetch(defaultChild["@id"]);
        } else {
            return new Promise((resolve, reject) => {
                reject();
            });
        }
    }

    getColor(object) {
        if(typeof object === "object") {
            let color = null;
            if(object["category-color"]) {
                if(object["category-color"]["title"]) {
                    // newer plone.restapi
                    color = object["category-color"]["title"].trim();
                } else {
                    // older plone.restapi
                    color = object["category-color"].trim();
                }
            }

            if(color && color.trim() !== "") {
                return new Promise((resolve) => {
                    resolve(color.trim().toLowerCase());
                });
            } else {
                if(object["parent"] && object["parent"]["@id"]) {
                    // we really want to handle the parent url
                    object = object["parent"]["@id"];
                } else {
                    return new Promise((resolve, reject) => {
                        reject();
                    });
                }
            }
        }

        if(typeof object === "string") {
            // we most probably got an url string
            return this.fetch(object)
                .then(data => {
                    return this.getColor(data);
                });
        }
    }
}

const ploneApi = new PloneApi();
export default ploneApi;



// WEBPACK FOOTER //
// ./api/PloneApi.js